import { COLORS, TYPO } from '@/b2b/shared/consts';
import { socialTelegramMono24, socialZenMono24 } from '@/b2b/shared/icons';
import { UiFlex } from '@/b2b/shared/ui';
import { FC } from 'react';
import styled from 'styled-components';
import { SocialIcon } from '../model/footer.consts';

interface SocialLink {
  url: string;
  target: string;
  icon: SocialIcon;
}

interface Props {
  socialLinks: SocialLink[];
}

const socialIcons: Record<SocialIcon, FC> = {
  [SocialIcon.ICON_DZEN]: socialZenMono24,
  [SocialIcon.ICON_TELEGRAM]: socialTelegramMono24,
  [SocialIcon.ICON_YOUTUBE]: socialTelegramMono24,
  [SocialIcon.ICON_UNSPECIFIED]: socialTelegramMono24,
  [SocialIcon.UNRECOGNIZED]: socialTelegramMono24,
};

export const SocialBlock: FC<Props> = ({ socialLinks }) => {
  return (
    <Container
      direction="column"
      gap={24}
    >
      <Title>Мы в соцсетях</Title>

      <SocialLinks gap={20}>
        {socialLinks.map((socialLink) => {
          const Icon = socialIcons[socialLink.icon];
          return (
            <SocialLink
              key={socialLink.url}
              href={socialLink.url}
              target={socialLink.target}
            >
              <SocialButton>
                <Icon />
              </SocialButton>
            </SocialLink>
          );
        })}
      </SocialLinks>
    </Container>
  );
};

const Container = styled(UiFlex)``;

const Title = styled.p`
    ${TYPO.body1Bold}
  color: ${COLORS.black};
`;

const SocialLinks = styled(UiFlex)``;

const SocialLink = styled.a`
  text-decoration: none;
`;

const SocialButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background-color: ${COLORS.grayscale50};
  cursor: pointer;
  padding: 0;

  &:hover {
    opacity: 0.8;
  }
`;
